export default function ConfirmDialog({ confirm, onCancel, onConfirm }) {
  if (!confirm) return null;
  // Document untag/remove by default; callers can pass title/body/okLabel
  // directly for any other confirmation (e.g. saving the financier selection).
  const isUntag = confirm.kind === "untag";
  const isCustom = !!confirm.title;
  const title = confirm.title || (isUntag ? "Untag this document?" : "Remove this document?");
  const body =
    confirm.body ||
    (isUntag
      ? confirm.name + " moves back to Auto-Fetched Docs."
      : confirm.name + " will be deleted from this application.");
  const okLabel = confirm.okLabel || (isUntag ? "Untag" : "Remove");

  return (
    <div className="overlay overlay--confirm" onClick={(e) => e.target === e.currentTarget && onCancel()}>
      <div className="confirm-box">
        <div className="confirm-box__title">{title}</div>
        <div className="confirm-box__body">{body}</div>
        <div className="confirm-box__actions">
          <button type="button" className="confirm-box__cancel" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="confirm-box__ok"
            style={{ background: isCustom || isUntag ? "var(--brand-cyan)" : "var(--danger)" }}
            onClick={onConfirm}
          >
            {okLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
